var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaHaciaAbajoParaNavegar8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91615 7.00821L11.81 3.11429C12.0634 2.86101 12.0634 2.45149 11.81 2.1982C11.5567 1.94492 11.1471 1.94492 10.8939 2.1982L6.99994 6.09212L3.10614 2.1982C2.85274 1.94492 2.44333 1.94492 2.19005 2.1982C1.93665 2.45149 1.93665 2.86101 2.19005 3.11429L6.08385 7.00821L2.19005 10.9021C1.93665 11.1554 1.93665 11.5649 2.19005 11.8182C2.31628 11.9446 2.48225 12.008 2.6481 12.008C2.81395 12.008 2.9798 11.9446 3.10614 11.8182L6.99994 7.9243L10.8939 11.8182C11.0202 11.9446 11.1861 12.008 11.3519 12.008C11.5178 12.008 11.6836 11.9446 11.81 11.8182C12.0634 11.5649 12.0634 11.1554 11.81 10.9021L7.91615 7.00821Z",
    fill: "#B1C20E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaHaciaAbajoParaNavegar8);
export default __webpack_public_path__ + "static/media/flecha-hacia-abajo-para-navegar 8.6c7a352a3d1bb3a7299e7adc745bf95c.svg";
export { ForwardRef as ReactComponent };